import { ApiProperty } from "@nestjs/swagger"
import { TrimItemsMappingDto } from "./trim-items-mapping-dto"

export class TrimsConfigurationDto{
    @ApiProperty()
    trimId:number
    @ApiProperty()
    brandId:number
    @ApiProperty()
    packStyleId:number
    @ApiProperty()
    variantId:number
    @ApiProperty()
    isActive:boolean
    @ApiProperty()
    createdAt: Date
    @ApiProperty()
    createdUser: string | null
    @ApiProperty()
    updatedAt: Date
    @ApiProperty()
    updatedUser: string | null
    @ApiProperty()
    versionFlag: number;
    @ApiProperty()
    trimItemsInfo: TrimItemsMappingDto[];
    @ApiProperty()
    endCustomerId:number;

}